<div class="min-vh-100 bg-light">
    <app-header [page]="'Support'"></app-header>

    <main class="container py-4">

        <a routerLink="/support/tickets" class="btn btn-sm btn-outline-secondary mb-3">
            ← Back
        </a>

        <div *ngIf="loading" class="text-center py-4">
            <div class="spinner-border spinner-border-sm"></div>
        </div>

        <div *ngIf="ticket" class="card shadow-sm border-0">
            <div class="card-body">

                <div class="d-flex justify-content-between align-items-center mb-3" *ngIf="ticket">
                    <div>
                        <h5 class="fw-bold mb-1">{{ ticket.subject }}</h5>
                        <div class="small text-muted">
                            {{ ticket.category }} • {{ ticket.status }}
                        </div>
                    </div>

                    <div class="d-flex gap-2">
                        <button *ngIf="ticket.status !== 'Closed'" class="btn btn-outline-danger btn-sm" type="button"
                            [disabled]="closing" (click)="confirmCloseTicket()">
                            {{ closing ? 'Closing...' : 'Close Ticket' }}
                        </button>

                        <button *ngIf="ticket.status === 'Closed'" class="btn btn-outline-primary btn-sm" type="button"
                            [disabled]="reopening" (click)="confirmReopenTicket()">
                            {{ reopening ? 'Reopening...' : 'Reopen Ticket' }}
                        </button>
                    </div>
                </div>

                <hr />

                <div class="mb-3">
                    <div *ngFor="let m of ticket.messages" class="mb-2">

                        <div class="p-2 rounded" [ngClass]="{
                'bg-primary text-white': m.senderType === 'User',
                'bg-light': m.senderType !== 'User'
              }">

                            <div class="small fw-bold">
                                {{ m.senderType }}
                            </div>

                            <div>{{ m.message }}</div>

                            <div class="small opacity-75">
                                {{ m.createdAt | date:'short' }}
                            </div>
                        </div>
                    </div>
                </div>

                <div class="d-flex gap-2">
                    <div *ngIf="ticket.status !== 'Closed'; else closedTicketNotice" class="d-flex gap-2">
                        <input [(ngModel)]="message" class="form-control" placeholder="Type your message..." />

                        <button class="btn btn-primary" [disabled]="sending" (click)="send()">
                            Send
                        </button>
                    </div>

                    <ng-template #closedTicketNotice>
                        <div class="alert alert-secondary mb-0">
                            This ticket is closed. Reopen it if you still need help.
                        </div>
                    </ng-template>
                </div>

            </div>
        </div>

        <app-footer></app-footer>
    </main>
</div>